import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import{ timeLoding} from "@/utils/index"

const service = axios.create({
  baseURL:process.env.VUE_APP_BASE_API_URL +"/api", 
  timeout: 20000
})

// 请求拦截器
service.interceptors.request.use(config => {
    timeLoding.open(config)
    if (store.getters.token) {
      config.headers['Authorization'] = `${store.getters.token}`
    }
    // 线上的和登录地址，不是线上的，并且接口不等于登录的才会加H5
    const flag = process.env.VUE_APP_IS_ADMIN_MODE === "true" && config.url!=='/auth/token/form'&&config.url!=='/auth/token/timedg'&&config.url!=='/auth/token/dgPlus'
    config.baseURL = config.baseURL+ (flag?'/h5':'')
    return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(response => {
  timeLoding.close(response.config.url, service._requestTimeIdList)
  const { code, message, data ,token} = response.data
  if (code == 200) {
    return  response.config.allRes?response.data:(data??token)
  }else if(code == 10001){
    if(!response.config.hideTip){
      Message.error(message||"未知错误，稍后再试") 
    }
    return Promise.reject(new Error(message))
  }else if(code == undefined) {
    return response.data
  }else{
    if(!response.config.hideTip){
      Message.error(message||"接口报错") 
    }
    return Promise.reject(new Error(message))
  }
}, error => {
  timeLoding.reset()
  if(error.response){
    Message.error(error.response.data.message||'服务器接口异常，请联系管理员') 
  }
  if(error.code === 'ECONNABORTED'){
    Message.error("数据响应超时,请重试")
  }
  return Promise.reject(error)
})

export default service


